import { type ReactNode, type FC, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Capacitor } from '@capacitor/core';
import { IonSpinner } from '@ionic/react';
import { performLogin } from '../utils/auth';

interface AuthGuardProps {
  children: ReactNode;
  returnTo?: string;
}

export const AuthGuard: FC<AuthGuardProps> = ({ children, returnTo }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const isMobile = Capacitor.isNativePlatform();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      performLogin(loginWithRedirect, { returnTo, isMobile });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, returnTo, isMobile]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <IonSpinner name="crescent" className="w-12 h-12" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="flex items-center justify-center h-screen">
        <IonSpinner name="crescent" className="w-12 h-12" />
      </div>
    );
  }

  return <>{children}</>;
};
